import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Controlla se l'host dell'URL corrisponde a quello che vuoi
    if (req.url.includes(environment.host)) {

      // Aggiungi l'intestazione Authorization con Basic Auth
      const basicAuth = 'Basic ' + btoa(`${environment.basicUsername}:${environment.basicPassword}`);

      // Clona la richiesta e aggiungi l'intestazione Authorization
      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: basicAuth
        }
      });

      // Passa la richiesta clonata
      return next.handle(clonedRequest);
    }

    // Se l'host non corrisponde, invia la richiesta senza modifiche
    return next.handle(req);
  }

}
